import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import structuredData from "../assets/structuredText";
import HomeFilter from "../components/HomeFilter";
import MemberPopup from "../components/MemberPopup";
import MembersButtonsGrid from "../components/MembersButtonsGrid";
import Slider from "../components/Slider";
import usePageReset from "../hooks/usePageReset";
import { type RootState } from "../redux/configureStore";

export default function Home() {
  const openMemberModal = useSelector((state: RootState) => state.memberModal.open);

  usePageReset();

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <meta
          name="keywords"
          content="cultiv entrepreneur startup members collective company consultation business growth idea"
        />
        <meta
          name="description"
          content="Cultiv Supporting innovation in all forms through venture building. We
connect global innovators, entrepreneurs, and market experts to build impactful
communities"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:url" content="https://cultiv.llc" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          itemProp="image"
          content="https://cultiv.llc/images/metaimg.jpg"
        />
        <link rel="image_src" itemProp="image" href="https://cultiv.llc/images/metaimg.jpg" />
        <meta
          property="og:description"
          content="Cultiv Supporting innovation in all forms through venture building. We
connect global innovators, entrepreneurs, and market experts to build impactful
communities"
        />
        <meta property="og:site_name" content="Cultiv LLC" />
        <meta property="og:title" content="Staging Cultiv LLC" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://cultiv.llc" />
        <meta property="twitter:title" content="Cultiv" />
        <meta
          property="twitter:description"
          content="Cultiv Supporting innovation in all forms through venture building. We
connect global innovators, entrepreneurs, and market experts to build impactful
communities"
        />
        <meta property="twitter:image" content="https://cultiv.llc/images/metaimg.jpg" />
        <link rel="canonical" href="https://cultiv.llc" />
        <script type="application/ld+json">{structuredData}</script>
        <title>Cultiv</title>
      </Helmet>
      <div className="w-full flex flex-col justify-center gap-5 lg:px-20 xl:px-30 lg:mt-8">
        <div className="w-full grid grid-cols-4 lg:grid-cols-12 gap-4 lg:gap-7.5">
          <div className="col-span-4 lg:col-span-8">
            <Slider />
          </div>
          <div
            className="flex flex-col gap-4 col-span-4 lg:col-span-4 px-6 md:px-15
           lg:px-0 w-full"
          >
            <h1 className="xl:text-3xl lg:text-xl md:text-2xl text-xl border-b-2 border-gray-400 w-full text-start pb-2 font-expanded">
              Collective Members
            </h1>
            <MembersButtonsGrid />
          </div>
        </div>
        {openMemberModal && <MemberPopup />}
        <div className="w-full flex flex-col gap-5 px-6 lg:px-0 justify-center md:px-15">
          <HomeFilter pageId="home" />
        </div>
      </div>
    </>
  );
}
